/**
 * 演示数据辅助函数
 */

/**
 * 对演示数据进行分页
 */
export function paginateDemoData<T>(data: T[], page: number, limit: number): T[] {
  const start = (page - 1) * limit;
  const end = start + limit;
  return data.slice(start, end);
}

/**
 * 对演示用户进行搜索过滤
 */
export function searchDemoUsers<T extends { username: string; phone: string | null }>(
  users: T[],
  query: string
): T[] {
  if (!query) return users;
  const lowerQuery = query.toLowerCase();
  return users.filter(
    (user) =>
      user.username.toLowerCase().includes(lowerQuery) ||
      (user.phone && user.phone.includes(query))
  );
}
